<template>
  <el-tag :type="type">
    {{ action }}
  </el-tag>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'

const ACTIONS: Record<string, string> = {
  update: 'warning',
  create: 'success',
  destroy: 'danger'
}

export default defineComponent({
  name: 'ActionLabel',
  props: {
    action: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const type = computed(() => {
      return ACTIONS[props.action]
    })
    return { type }
  }
})
</script>
